"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7 13h4v4H7zm6 0h4v4h-4z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M7 7h4v4H7zm6 0h4v4h-4z"
}, "2")], 'DatasetOutlined');